import React from "react";

// Her bölüm başlığı için ortak renderer. Gradient accent content dosyasındaki "accent" alanından gelir.
export default function SectionTitle({ lead, accent, tail, className = "" }) {
  return (
    <h2 className={`section-title ${className}`}>
      {lead}
      {accent ? <span className="gradient-text">{accent}</span> : null}
      {tail}
    </h2>
  );
}